import React from 'react';
import PropTypes from 'prop-types';
import ConnectedViewerRetrieveStudyData from '../connectedComponents/ConnectedViewerRetrieveStudyData';

function ViewerRouting({ match }) {
	const { studyInstanceUids, seriesInstanceUids, sopInstanceUids } = match.params;

	let studyUIDs;
	let seriesUIDs;
	let sopUIDs;

	if (studyInstanceUids && !seriesInstanceUids) {
		studyUIDs = studyInstanceUids.split(';');
	} else if (studyInstanceUids && seriesInstanceUids && sopInstanceUids) {
		studyUIDs = [studyInstanceUids];
		seriesUIDs = match.params.seriesInstanceUids.split(';');
		sopUIDs = match.params.sopInstanceUids.split(';');
	}

	return (
		<ConnectedViewerRetrieveStudyData
			studyInstanceUids={studyUIDs}
			seriesInstanceUids={seriesUIDs}
			sopInstanceUids={sopUIDs}
		/>
	);
}

ViewerRouting.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			studyInstanceUids: PropTypes.string.isRequired,
			seriesInstanceUids: PropTypes.string,
			sopInstanceUids: PropTypes.string
		})
	})
};

export default ViewerRouting;
